import { createLoadFactor } from "../components/helper";
import useOrgAreaIndicators from "./useOrgAreaIndicators";

const useOrgStatusAreaIndicators = (status) => { 
    const { organizationAreaIndicatorsData, isSearching } =
        useOrgAreaIndicators(createLoadFactor("com.back2blu.plans.service.loadfactor.AreaIndicatorLoadItem", 'BASIC', 'STATUS_TREND_PROGRESS', 'AREA', 'PLAN'));
    
    const filteredData = organizationAreaIndicatorsData?.filter(item => item.status === status);
    const percentage = (filteredData?.length / organizationAreaIndicatorsData?.length) * 100;
    const totalCount = organizationAreaIndicatorsData?.length;
    return { organizationAreaIndicatorsData: filteredData, percentage, totalCount, isSearching };
};

export default useOrgStatusAreaIndicators;